import { LegalEntitySelectorViewModel } from "../../legalEntity/LegalEntity.types";
import { useUserContext } from "../../auth/userContextProvider/UserContextProvider.tsx";

import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";

export function useGroupEntitiesQuery(enabled?: boolean) {
    const userCtx = useUserContext();

    let url = "/LegalEntity/groupentities/";
    let query = useDotLegalQuery<Array<LegalEntitySelectorViewModel>>(url, {
        enabled: enabled === undefined ? true : enabled,
    });

    const showGroupEntitySelector = query.data && query.data?.length > 1 && userCtx.gdpo;

    return {
        allGroupEntities: query.data,
        isLoading: query.isLoading,
        showGroupEntitySelector,
    };
}

export function useExternalEntitiesQuery(enabled?: boolean) {
    let url = "/LegalEntity/externalEntities/";
    let query = useDotLegalQuery<Array<LegalEntitySelectorViewModel>>(url, {
        enabled: enabled === undefined ? true : enabled,
    });

    return {
        allExternalEntities: query.data,
        isLoading: query.isLoading,
    };
}
